import en from './en.json'
import es from './es.json'
import ru from './ru.json'
import fr from './fr.json'
import pt from './pt.json'
import zh_cn from './zh-CN.json'
import zh_tw from './zh-TW.json'
import de from './de.json'
import it from './it.json'
import ar from './ar.json'
import pl from './pl.json'
import ja from './ja.json'
import tr from './tr.json'
import uk from './uk.json'
import ko from './ko.json'
import hi from './hi.json'
import he from './he.json'
import vi from './vi.json'

export const defaultLocale = 'en'

export const languages = {
    en: en,
    es: es,
    ru: ru,
    fr: fr,
    pt: pt,
    zh_cn: zh_cn,
    zh_tw: zh_tw,
    de: de,
    it: it,
    ar: ar,
    pl: pl,
    ja: ja,
    tr: tr,
    uk: uk,
    ko: ko,
    hi: hi,
    he: he,
    vi: vi
}
